import { getMykissEnv } from './getMykissEnv';

export function isProduction(): boolean {
  return getMykissEnv() === 'production';
}
